
import React from 'react';
import { TextField } from 'office-ui-fabric-react/lib/TextField';

const TEXTFIELD_LABEL_STYLES = {
    subComponentStyles: {
        label: {
            root: {
                //color: theme.fabricTheme.palette.neutralTertiary
            }
        }
    }
};

const FilterItemText = (props) => {

    const handleChange = (e) => {
        if (props.onChange) {
            props.onChange(props.definition.id, e.target.value);
        }
    }

    return (
        <TextField
            label={props.definition.title}
            value={props.value || ''}
            onChange={handleChange}
            styles={TEXTFIELD_LABEL_STYLES}
        />
    );
}

export default FilterItemText;
